import { render, staticRenderFns } from "./ResourceFormRow.vue?vue&type=template&id=5dce4f2e&scoped=true"
import script from "./ResourceFormRow.vue?vue&type=script&lang=ts"
export * from "./ResourceFormRow.vue?vue&type=script&lang=ts"
import style0 from "./ResourceFormRow.vue?vue&type=style&index=0&id=5dce4f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dce4f2e",
  null
  
)

export default component.exports